import React from "react";
import Paper from "@material-ui/core/Paper";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import { UserInScheduleWithPermissions } from "../../../../../../../interfaces/user";
import { useUsersStyles } from "../../../../../styles";
import EmptyState from "../../../../../../../Components/EmptyState";
import RemoveProfileButton from "./components/remove-profile";
import { useGetUser } from "../../../../../../../services/api-tansquery/user/details";
import { useUserProfiles } from "../../../../../../../services/api-tansquery/user/profile-management";

type ProfileTableProps = {
  user: UserInScheduleWithPermissions;
};

const ProfileTable: React.FC<ProfileTableProps> = ({ user }) => {
  const { classes } = useUsersStyles();
  
  const { data: refreshedUser } = useGetUser(String(user.id));
  const actualUser = refreshedUser || user;
  
  // Buscar perfis com informações de permissão e órgãos
  const { data: profilesData } = useUserProfiles(actualUser.id);

  const getProfileDisplayName = (profile: string) => {
    const displayNames: Record<string, string> = {
      "Administrador de Atendimento": "Administrador",
      "Gerente de Atendimento": "Gerente de Atendimento",
      "Coordenador de Atendimento": "Coordenador de Atendimento",
      "Atendente": "Atendente"
    };
    return displayNames[profile] || profile;
  };

  // Se temos dados do endpoint, usar eles. Caso contrário, usar dados do usuário
  const profiles = profilesData?.profiles || [];
  const atendimentoProfiles = ['Administrador de Atendimento', 'Gerente de Atendimento', 'Coordenador de Atendimento', 'Atendente'];
  
  // Se não temos dados do endpoint, usar as permissões do usuário como fallback
  const displayProfiles = profiles.length > 0 
    ? profiles 
    : (actualUser.permissions?.filter((p: string) => atendimentoProfiles.includes(p)) || []).map((p: string) => ({
        name: p,
        display_name: getProfileDisplayName(p),
        can_remove: true, // Fallback: assumir que pode remover se não temos dados
        orgaos: [],
        has_multiple_orgaos: false
      }));

  return (
    <Paper elevation={3}>
      <TableContainer className={classes.tableContainer}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell className={classes.tableTH}>Perfil</TableCell>
              <TableCell className={classes.tableTH} />
            </TableRow>
          </TableHead>
          <TableBody>
            {displayProfiles.map((profile: any, index: number) => (
              <TableRow key={`${profile.name || profile}-${index}`}>
                <TableCell className={classes.tableCell}>
                  {profile.display_name || getProfileDisplayName(profile.name || profile)}
                </TableCell>
                <TableCell className={classes.tableCell} align="right">
                  <RemoveProfileButton
                    user={actualUser}
                    profileToRemove={profile.name || profile}
                    canRemove={profile.can_remove !== false}
                    orgaos={profile.orgaos || []}
                    hasMultipleOrgaos={profile.has_multiple_orgaos || false}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        {!displayProfiles.length && <EmptyState message="Nenhum perfil vinculado." />}
      </TableContainer>
    </Paper>
  );
};

export default ProfileTable;